export default "__VITE_ASSET__BvM_AFT0__"